/* unplugin-vue-components disabled */import { render } from "./MossRender.vue?vue&type=template&id=8ab6640e&scoped=true"
import script from "./MossRender.vue?vue&type=script&lang=js"
export * from "./MossRender.vue?vue&type=script&lang=js"

import "./MossRender.vue?vue&type=style&index=0&id=8ab6640e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab6640e"]])

export default __exports__